import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from "../../../store/actions";
import {
  IconButton,
  Container,
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
} from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { i18n } from '../../../translate/i18n';
import EquipmentsTable from './EquipmentsTable/EquipmentsTable';
import Checklist from './Checklist/Checklist';
import EquipmentServicesList from './EquipmentServicesList/EquipmentServicesList';
import { RouteComponentProps, useLocation } from 'react-router-dom';

interface RouteParams {
  step: string
}

interface Props extends RouteComponentProps<RouteParams> {
}

const CreateService: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const [step, setStep] = useState<number>(Number(props.match.params.step));

  const location = useLocation();

  const goBack = () => props.history.goBack();
  
  console.log('location state', location);
  const handleBack = () => {
    dispatch(actions.createServiceClearServiceFilesAndSignature())
    if ((step === 1 && props.match.params.step === "1") || step === 0 || (step === 2 && props.match.params.step === "2")) return goBack();
    return setStep(step - 1);
  };

  const steps = [i18n.t('createService.step0'), i18n.t('createService.step1'), i18n.t('createService.step2')];

  useEffect(() => {
    let clearDraftId = true;
    if (props.location.state) clearDraftId = !((props.location.state as any).from === '/service-drafts');
    dispatch(actions.clearCreateService(clearDraftId));
  }, [])

  return <>
    <Box sx={{display: 'flex'}}>
      <IconButton onClick={handleBack} sx={styles.arrowBack} size="large"><ArrowBack /></IconButton>

        <Container maxWidth='lg'>
          
          <Typography sx={styles.title} variant='h5'>{i18n.t('typographyFormService.true') as string}</Typography>
          <Stepper sx={styles.stepper} activeStep={step}>
            {steps.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {step === 0 && <EquipmentsTable setStep={setStep} />}
          {step === 1 && <EquipmentServicesList setStep={setStep} showButton={props.match.params.step !== "1"} />}
          {step === 2 && <Checklist goBack={goBack} />}
        </Container>
    </Box>
  </>
};

const styles = {
  arrowBack: {
    alignSelf: 'flex-start',
  },
  title: {
    marginTop: '10px',
    marginBottom: '50px',
  },
  stepper: {
    marginBottom: '80px',
  },
}

export default CreateService;
